import ErrorIcon from '@mui/icons-material/Error'
import { Tab } from '@mui/material'
import type { JSX } from 'react'

export interface CustomTabProps {
  error: boolean
  label: string
}

const TabPanel = ({ error, label, ...props }: CustomTabProps): JSX.Element => {
  const iconProps = error ? { icon: <ErrorIcon style={{ color: 'red' }} /> } : {}

  return <Tab label={label} iconPosition="start" {...props} {...iconProps} sx={[error && { color: 'red' }]} />
}

export default TabPanel
